module.exports = __webpack_public_path__ + "static/media/user_picture.4453db56.png";